import Vue from 'vue';

export const CART_GETTERS = {
  CART_CONTEXT: 'cartContext',
  CART_EXTRA: 'cartExtra',
};

export const CART_ACTIONS = {
  SET_CART_CONTEXT: 'setCartContext',
  SET_CART_EXTRA: 'setCartExtra',
};

export const CART_MUTATIONS = {
  SET_CART_CONTEXT: 'setCartContext',
  SET_CART_EXTRA: 'setCartExtra',
};

export default {
  namespaced: true,
  state: {
    cartContext: {
      products: [{
        pid: 0,
        billingcycle: "monthly",
        config_opts: {},
        customfields: {}
      }],
      domains: [{}],
      add_products: [],
      promo: "string",
      currency: 0,
      language: "string"
    },
    cartExtra: {
      domain: [],
      hosting: []
    }
  },
  getters: {
    [CART_GETTERS.CART_CONTEXT]: (state) => state.cartContext,
    [CART_GETTERS.CART_EXTRA]: (state) => state.cartExtra
  },
  actions: {
    [CART_ACTIONS.SET_CART_CONTEXT]: async ({commit}, cartContext) => {
      commit(CART_MUTATIONS.SET_CART_CONTEXT, cartContext)
    },
    [CART_ACTIONS.SET_CART_EXTRA]: async ({commit}, cartExtra) => {
      commit(CART_MUTATIONS.SET_CART_EXTRA, cartExtra)
    },
  },
  mutations: {
    [CART_MUTATIONS.SET_CART_CONTEXT]: (state, {
      pid, billingcycle, productCustomfields, configOpts,
      pidUpsell, billingcycleUpsell, customfieldsUpsell, configOptsUpsell,
      domain, type, domainBillingcycle, idprotection, domainsCustomfields,
      codeEpp, promo, currency, language
    }) => {

      const updateProduct = (index, { newPid, newBillingcycle, newCustomfields, newConfigOpts }) => {
        const product = state.cartContext.products[index];
        if (product) {
          product.pid = newPid >= 0 ? newPid : product.pid;
          product.billingcycle = newBillingcycle || product.billingcycle;
          product.customfields = newCustomfields || product.customfields;
          product.config_opts = newConfigOpts || product.config_opts;
        }
      };

      updateProduct(0, {
        newPid: pid,
        newBillingcycle: billingcycle,
        newCustomfields: productCustomfields,
        newConfigOpts: configOpts
      });

      if (pidUpsell > 0 || billingcycleUpsell) {
        if (!state.cartContext.products[1]) {
          state.cartContext.products[1] = {pid: 0, billingcycle: "monthly", config_opts: {}, customfields: {}
          };
        }
        updateProduct(1, {
          newPid: pidUpsell,
          newBillingcycle: billingcycleUpsell,
          newCustomfields: customfieldsUpsell,
          newConfigOpts: configOptsUpsell
        });
      } else if (pidUpsell === 0 && state.cartContext.products[1]) {
          state.cartContext.products.splice(1, 1);
      }

      if (!state.cartContext.domains || !state.cartContext.domains[0]) {
        state.cartContext.domains = [{
          domain: '',
          type: '',
          billingcycle: '',
          idprotection: undefined,
          customfields: {},
          codeEpp: undefined
        }];
      }

      state.cartContext.domains[0].domain = domain || state.cartContext.domains[0].domain;
      state.cartContext.domains[0].type = type || state.cartContext.domains[0].type;
      state.cartContext.domains[0].billingcycle = domainBillingcycle || domainBillingcycle === 0 ? domainBillingcycle : state.cartContext.domains[0].billingcycle;
      state.cartContext.domains[0].idprotection = idprotection || undefined;
      state.cartContext.domains[0].customfields = domainsCustomfields || state.cartContext.domains[0].customfields;
      state.cartContext.domains[0].codeEpp = codeEpp || undefined;

      state.cartContext.promo = promo !== undefined ? promo : state.cartContext.promo;
      state.cartContext.currency = currency || state.cartContext.currency;
      state.cartContext.language = language || state.cartContext.language;
    },
    [CART_MUTATIONS.SET_CART_EXTRA]: (state, {domainItem, hostingItem}) => {
      if(domainItem) {
        const index = state.cartExtra.domain.findIndex((el) => el.id === domainItem.id);
        if(index === -1) {state.cartExtra.domain.push(domainItem)}
        else { Vue.set(state.cartExtra.domain, index, domainItem) }
        state.cartExtra.domain = state.cartExtra.domain.filter(item => item.price || item.price > 0)
      }
      if(hostingItem) {
        const index = state.cartExtra.hosting.findIndex((el) => el.id === hostingItem.id);
        if(index === -1) {state.cartExtra.hosting.push(hostingItem)}
        else { Vue.set(state.cartExtra.hosting, index, hostingItem) }
        state.cartExtra.hosting = state.cartExtra.hosting.filter(item => item.price || item.price !== 0)
      }
    },
  },
}
